// extracted by mini-css-extract-plugin
module.exports = {"xsBreakpoint":"600px","smBreakpoint":"960px","mdBreakpoint":"1264px"};